import React, { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { ListQuery } from '../../models/ListQuery';
import Label from "../label/label";
import {useFormikContext} from "formik";
import PaginatedSearchableSelectField from "../selection-field/paginated-searchable-select-field";
import {getReaderNames} from "../../services/readerService";
import {Door} from "../../models/Door";
import { Button } from '../button/Button';
import closeIcon from '../../images/close.svg';
interface AssignModalProps {
    isOpen: boolean,
    onClose: () => any,
    title: string,
    handleOnSubmit: (values: any) => any,
    decoupleReader?: (readerId) => any,
    currentItem: Door,
    setFormikContext: (formikContext) => void,
}

const ReaderAssignModal: FC<AssignModalProps> = ({ isOpen, onClose, title, handleOnSubmit, decoupleReader = (readerId) => { }, currentItem, setFormikContext}) => {
    const { translate } = useLocale();
    const formikContext = useFormikContext<any>();


    useEffect(() => {
        setFormikContext(formikContext)
    }, [])

    const onSubmit = () => {
        handleOnSubmit(formikContext.values);
        localOnClose();
    }

    const deleteReader = (readerId, reader)=>{
        if(readerId){
            decoupleReader(readerId)
            formikContext.setFieldValue(reader, "");
        }
    }

    const localOnClose = () => {
        onClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <div className="flex flex-col">
                <div className="w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between">
                    <span className="pl-3 font-bold text-white">{title}</span>
                    <img src={closeIcon} onClick={localOnClose} className="cursor-pointer mr-2" />
                </div>
                <div className="flex flex-col py-4 px-8">
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id='zoneLabelId'>
                            <Label
                                htmlFor="zoneId"
                                className="text-xs text-gray-600 mt-1" >{translate.byKey(TranslationKeys.entryReader)}:</Label>
                            {formikContext.errors.entryReaderId ? <span className='text-red-600 text-xs'>{formikContext.errors.entryReaderId}</span> : null}
                        </div>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.entryReader)}
                            key="entryReaderId"
                            accessor='entryReaderId'
                            dataMethod={(listParameter: ListQuery) => getReaderNames(listParameter, true)}
                            searchAccessor={'zoneName'}
                            onDelete={(event) => deleteReader(formikContext.values.entryReaderId, 'entryReaderId')}
                            onSelect={(_,item) => {
                                formikContext.setFieldValue('entryReader', item?.label)
                                formikContext.setFieldValue('entryReaderId', item?.value)
                             }}
                            selectedItemLabel={formikContext.values.entryReader??""}
                            disabled={!!currentItem.entryReaderId}/>
                    </div>
                    <div className="mt-2">
                        <div className="flex flex-row justify-between" id='zoneLabelId'>
                            <Label
                                htmlFor="zoneId"
                                className="text-xs text-gray-600 mt-1" >{translate.byKey(TranslationKeys.exitReader)}:</Label>
                            {formikContext.errors.exitReaderId ? <span className='text-red-600 text-xs'>{formikContext.errors.exitReaderId}</span> : null}
                        </div>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.exitReader)}
                            key="exitReaderId"
                            accessor='exitReaderId'
                            dataMethod={(listParameter: ListQuery) => getReaderNames(listParameter, true)}
                            searchAccessor={'zoneName'}
                            onDelete={(event) => deleteReader(formikContext.values.exitReaderId, 'exitReaderId')}
                            onSelect={(_,item) => {
                                formikContext.setFieldValue('exitReader', item?.label)
                                formikContext.setFieldValue('exitReaderId', item?.value)
                             }}
                            selectedItemLabel={formikContext.values.exitReader}
                            disabled={!!currentItem.exitReaderId}/>
                    </div>
                </div>
                <div className="flex flex-row pb-3 pr-3 pt-3 gap-3 justify-end">
                    <Button variant="outline" onClick={localOnClose}>
                        {translate.byKey(TranslationKeys.cancel)}
                    </Button>
                    <Button id='submitAssignButtonId' variant="submit" type="button" onClick={onSubmit}>
                        {translate.byKey(TranslationKeys.confirm)}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ReaderAssignModal;
